import './BarcodeScanner.scss';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ScanditBarcodeScanner from 'scandit-sdk-react';

import Button from '@/common/components/atoms/Button/Button';
import Snack from '@/common/components/molecules/Snack/Snack';

import {
  BarcodeScannerDefaultProps,
  BarcodeScannerPropTypes,
} from './BarcodeScanner.proptypes';
import BarcodeScannerItem from './BarcodeScannerItem/BarcodeScannerItem';
import CONFIG from './config';
import useBarcodeScanner from './useBarcodeScanner';

const BarcodeScanner = ({
  className,
  disabled,
  onScanResult,
  onValidatePopin,
  isLogin,
  handleUpdateQuickEntry,
}) => {
  const { t } = useTranslation();
  const [isPopinVisible, setIsPopinVisible] = useState(false);
  const [product, setProduct] = useState({});

  const togglePopin = (data) => {
    setProduct([]);
    setIsPopinVisible(true);
    handleUpdateQuickEntry(data.barcodes[0].data, null, (item) =>
      setProduct(item),
    );
  };

  const {
    buttonLabel,
    classNames,
    onToggleScan,
    scanSettings,
    setBarcode,
  } = useBarcodeScanner({ className, onScanResult, togglePopin, isLogin });

  return (
    <div className={classNames}>
      <div className="barcode-scanner__scandit">
        <ScanditBarcodeScanner
          engineLocation={CONFIG.scandit.engineLocation}
          guiStyle={CONFIG.scandit.guistyle}
          licenseKey={CONFIG.scandit.licenseKey}
          onScan={(data) => setBarcode(data)}
          onScanError={() =>
            toast.error(
              <Snack message={t('common:messages:forms.errors.default')} />,
            )
          }
          scanSettings={scanSettings}
          videoFit={CONFIG.scandit.videoFit}
          zoom={CONFIG.scandit.zoom}
        />
      </div>
      <Button
        buttonSize="medium"
        className="barcode-scanner__toggle"
        disabled={disabled}
        onClick={onToggleScan}
        variant="primary"
      >
        {buttonLabel}
      </Button>
      {isPopinVisible && (
        <>
          <div
            className="overlay"
            role="presentation"
            onClick={() => setIsPopinVisible(false)}
          />
          <BarcodeScannerItem
            brand={product[0]?.brand}
            customerPrice={product[0]?.price_and_stock?.price?.customer_price}
            discountPrice={product[0]?.price_and_stock?.price?.discount_price}
            discountPriceTTC={
              product[0]?.price_and_stock?.price?.discount_price_incl_vat
            }
            publicPrice={product[0]?.price_and_stock?.price?.public_price}
            ebatExists={product[0]?.ebat_exists}
            image={product[0]?.image}
            name={product[0]?.name}
            id={product[0]?.id}
            publicPriceTTC={
              product[0]?.price_and_stock?.price?.invoice?.public_price_incl_vat
            }
            invoiceUnit={product[0]?.price_and_stock?.invoice_unit}
            isLoading={product.length === 0}
            isVisible={isPopinVisible}
            manufacturerSku={product[0]?.manufacturer_sku}
            salesPackaging={product[0]?.sales_packaging}
            splitPackaging={product[0]?.split_packaging}
            saleUnit={product[0]?.price_and_stock?.sale_unit}
            sku={product[0]?.sku}
            onValidatePopin={onValidatePopin}
            setIsVisible={setIsPopinVisible}
          />
        </>
      )}
    </div>
  );
};

BarcodeScanner.defaultProps = {
  ...BarcodeScannerDefaultProps,
};

BarcodeScanner.propTypes = {
  ...BarcodeScannerPropTypes,
};

export default BarcodeScanner;
